<template>
  <div>
    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog as="div" class="relative z-30 2xl:hidden" @close="close()">
        <TransitionChild
          as="template"
          enter="transition-opacity ease-linear duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0">
          <div class="fixed inset-0 bg-neutral-900/80" />
        </TransitionChild>

        <div class="fixed inset-0 flex">
          <TransitionChild
            as="template"
            enter="transition ease-in-out duration-300 transform"
            enter-from="-translate-x-full"
            enter-to="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leave-from="translate-x-0"
            leave-to="-translate-x-full">
            <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
              <TransitionChild
                as="template"
                enter="ease-in-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in-out duration-300"
                leave-from="opacity-100"
                leave-to="opacity-0">
                <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
                  <button type="button" class="-m-2.5 p-2.5" @click="close()">
                    <span class="sr-only">Close sidebar</span>
                    <i class="fa-sharp fa-regular fa-times text-white" aria-hidden="true"></i>
                  </button>
                </div>
              </TransitionChild>
              <NtNavigationSidebar />
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div class="hidden 2xl:fixed 2xl:inset-y-0 2xl:z-30 2xl:flex 2xl:w-72 2xl:flex-col">
      <NtNavigationSidebar />
    </div>
  </div>
</template>

<script>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import NtNavigationSidebar from './NtNavigationSidebar.vue'

export default {
  components: {
    Dialog, // eslint-disable-line vue/no-reserved-component-names
    DialogPanel,
    TransitionChild,
    TransitionRoot,
    NtNavigationSidebar
  },
  data() {
    return {
      sidebarOpen: false
    }
  },
  methods: {
    open() {
      this.sidebarOpen = true
    },
    close() {
      this.sidebarOpen = false
    }
  },
  watch: {
    $route() {
      this.close()
    }
  }
}
</script>
